exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-21011474] {\n  font-size: 1.5rem;\n  line-height: 1;\n  margin: 0;\n  top: 1rem;\n  left: 1rem;\n  position: absolute;\n  cursor: pointer;\n}\n.logo-offset[data-v-21011474] {\n  font-size: 0.9em;\n  display: inline-block;\n  transform: translate(-0.9rem, 0.3rem);\n}\n.logo-reveal[data-v-21011474] {\n  width: 0;\n  opacity: 0;\n  font-size: 0.8em;\n  display: inline-block;\n  transition: width 0.75s var(--bounce), opacity 0.6s var(--bounce);\n}\n.logo:hover .logo-reveal[data-v-21011474] {\n  opacity: 1;\n  width: 2.5rem;\n  transition: width 0.4s var(--bounce), opacity 0.5s var(--bounce);\n}", ""]);

// exports
